import React, { useState, useEffect } from 'react';
import './adsOn.css';

const AdsOn = () => {
    const bearerToken = localStorage.getItem('bearerToken');
    const handleLogout = () => {
        localStorage.removeItem('bearerToken');
        sessionStorage.clear();

        window.location.href = '/login';
    };

    const [activeTab, setActiveTab] = useState('seats'); // Default tab is "seats"

    // Debug to check activeTab switching
    useEffect(() => {
        console.log("Active tab is:", activeTab);
    }, [activeTab]);

    const handleTabClick = (tab) => {
        setActiveTab(tab); // Update the active tab
    };

    return (
        <>
            <div className="pricingContainer text-start">
                <div className="mainNavbarContainer">
                    <div className="navbarBox">
                        <a href="/home"><img src="./assets/logoBBT.png" alt="" className="logoBBTImg" /></a>
                        <img src="./assets/logoutBtn.png" alt="" className="logoutBtnImg" onClick={handleLogout} />
                    </div>
                </div>
                <div className="headertwo">
                    <p className="container text-start px-4 py-3">Complete Your Booking</p>
                </div>
                <div className="container row m-auto">
                    <div className="col-lg-3 p-0 mt-5">
                        <div className="w-100">
                            <div className="fare-summary-card">
                                <div className="title">Fare Summary</div>
                                <div className="row">
                                    <div className="col-8">Base Fare</div>
                                    <div className="col-4 text-right">₹10,945</div>
                                </div>
                                <div className="row">
                                    <div className="col-8">Taxes &amp; Surcharge</div>
                                    <div className="col-4 text-right">₹2,097</div>
                                </div>
                                <div className="row">
                                    <div className="col-8">Discounts</div>
                                    <div className="col-4 text-right">-₹959</div>
                                </div>
                                <hr />
                                <div className="row">
                                    <div className="col-8 total-amount">Total Amount</div>
                                    <div className="col-4 text-right total-amount">₹12,893</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-9 mt-5">
                        <div className="addoncontainer w-100">
                            <div className="section">
                                <h2>
                                    Flight Summary{" "}
                                    <img className="edit-icon" src="./images/editICon.png" alt="" />
                                </h2>
                                <div>
                                    <p>New Delhi ➔ Dubai</p>
                                    <p>Sat, 15 Jun | Non-stop | 4h 15m | Economy</p>
                                </div>
                            </div>
                        </div>
                        <div className="addoncontainer w-100 mt-3">
                            <div className="section">
                                <h2>
                                    Traveler's Details{" "}
                                    <img className="edit-icon" src="./images/editICon.png" alt="" />{" "}
                                </h2>
                                <div>
                                    <p>User's Name</p>
                                </div>
                            </div>
                        </div>
                        <div className="addoncontainer w-100 mt-3">
                            <div className="section">
                                <h2>
                                    Seats &amp; Meals{" "}
                                    <img className="edit-icon" src="./images/editICon.png" alt="" />
                                </h2>
                            </div>
                            <div className="addonplanedetails">
                                <div className="seatnmealscontainer">
                                    <div className="tabs">
                                        <div
                                            className={`tab ${activeTab === 'seats' ? 'active' : ''}`}
                                            onClick={() => handleTabClick('seats')}
                                        >
                                            Seats
                                        </div>
                                        <div
                                            className={`tab ${activeTab === 'meals' ? 'active' : ''}`}
                                            onClick={() => handleTabClick('meals')}
                                        >
                                            Meals
                                        </div>
                                    </div>

                                    {/* Conditionally render seats content */}
                                    {activeTab === 'seats' && (
                                        <div id="seats" className="content active">
                                            <div>
                                                <div className="legend">
                                                    <div>
                                                        <div className="seat free" />
                                                        <div className="mx-3">Free</div>
                                                    </div>
                                                    <div>
                                                        <div className="seat low" />
                                                        <div className="mx-3">₹ 150 - ₹ 350</div>
                                                    </div>
                                                    <div>
                                                        <div className="seat medium" />
                                                        <div className="mx-3">₹ 400 - ₹ 2000</div>
                                                    </div>
                                                    <div>
                                                        <div className="seat exit" />
                                                        <div className="mx-3">Exit Row Seats</div>
                                                    </div>
                                                    <div>
                                                        <div className="seat extra" />
                                                        <div className="mx-3">Extra Legroom</div>
                                                    </div>
                                                </div>
                                                <div style={{ width: '70%' }}>
                                                    <div className="seat-layout">
                                                        <div className="text-center mt-5 seatscontainer">
                                                            <div className="row">
                                                                <div className="col">
                                                                    <span className="exit">EXIT</span>
                                                                </div>
                                                                <div className="col-10">
                                                                    <table className="table table-borderless">
                                                                        <thead>
                                                                            <tr>
                                                                                <th />
                                                                                <th>A</th>
                                                                                <th />
                                                                                <th>B</th>
                                                                                <th />
                                                                                <th>C</th>
                                                                                <th />
                                                                                <th>D</th>
                                                                                <th />
                                                                                <th>E</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td>01</td>
                                                                                <td className="seat1 free" />
                                                                                <td />
                                                                                <td className="seat1 extra" />
                                                                                <td />
                                                                                <td className="seat1 free" />
                                                                                <td />
                                                                                <td className="seat1 extra" />
                                                                                <td />
                                                                                <td className="seat1 free" />
                                                                                <td>01</td>
                                                                            </tr>
                                                                            {/* Add more rows as needed */}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                                <div className="col">
                                                                    <span className="exit">EXIT</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {/* Conditionally render meals content */}
                                    {activeTab === 'meals' && (
                                        <div id="meals" className="content active">
                                            <div className="toggleContainer">
                                                <label htmlFor="veg">Veg</label>
                                                <label className="switch">
                                                    <input type="checkbox" defaultChecked />
                                                    <span className="slider round" />
                                                </label>
                                                <label htmlFor="veg">Non-Veg</label>
                                            </div>
                                            <div className="container mt-5">
                                                <div className="row">
                                                    {/* Repeat this block for each menu item */}
                                                    <div className="col-lg-4 mb-4">
                                                        <div className="card">
                                                            <img
                                                                src="./assets/images/mealImage.png"
                                                                className="card-img-top"
                                                                alt="Paneer Tikka Sandwich"
                                                            />
                                                            <div className="card-body text-center p-3">
                                                                <h6 className="card-title">Paneer Tikka Sandwich + Beverages</h6>
                                                                <p className="card-text">₹ 400</p>
                                                                <a href="#" className="btn btn-primary w-100">
                                                                    ADD
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* Repeat this block ends */}

                                                    <div className="col-lg-4 mb-4">
                                                        <div className="card">
                                                            <img
                                                                src="./assets/images/mealImage.png"
                                                                className="card-img-top"
                                                                alt="Paneer Tikka Sandwich"
                                                            />
                                                            <div className="card-body text-center p-3">
                                                                <h6 className="card-title">Paneer Tikka Sandwich + Beverages</h6>
                                                                <p className="card-text">₹ 400</p>
                                                                <a href="#" className="btn btn-primary w-100">
                                                                    ADD
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 mb-4">
                                                        <div className="card">
                                                            <img
                                                                src="./assets/images/mealImage.png"
                                                                className="card-img-top"
                                                                alt="Paneer Tikka Sandwich"
                                                            />
                                                            <div className="card-body text-center p-3">
                                                                <h6 className="card-title">Paneer Tikka Sandwich + Beverages</h6>
                                                                <p className="card-text">₹ 400</p>
                                                                <a href="#" className="btn btn-primary w-100">
                                                                    ADD
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>

                            </div>
                        </div>
                        <div className="airportPickdropService">
                            <div className="section">
                                <h2>Airport Pick &amp; Drop</h2>
                            </div>
                            <div className="container py-2">
                                {/* Cab to New Delhi Airport */}
                                <div className="cab-title my-2">
                                    <input type="checkbox" className="checkboxsize" />
                                    <label className="mb-0">Cab to New Delhi Airport</label>
                                </div>
                                <div className="cab-container">
                                    <div className="row align-items-center">
                                        <div className="col-md-4">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Pick-up"
                                                defaultValue="Pick-up"
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <input
                                                type="text"
                                                className="form-control"
                                                defaultValue="Terminal 3 Delhi Airport, IGI"
                                                readOnly=""
                                            />
                                        </div>
                                        <div className="travellersDetaildate col-md-4">
                                            <div className="text-dark price">
                                                <span>15 June 2024</span>
                                            </div>
                                            <div className="price">₹ 350</div>
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-md-12">
                                            <small>Flat ₹350 up to 10 kms</small>
                                        </div>
                                    </div>
                                </div>
                                {/* Cab from Dubai Airport */}
                                <div className="cab-title mt-4">
                                    <input type="checkbox" className="checkboxsize" />
                                    <label className="mb-0">Cab From Dubai Airport</label>
                                </div>
                                <div className="cab-container mt-2">
                                    <div className="row align-items-center">
                                        <div className="col-md-4">
                                            <input
                                                type="text"
                                                className="form-control"
                                                defaultValue="Terminal 1 Dubai International Airport"
                                                readOnly=""
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Drop Off"
                                            />
                                        </div>
                                        <div className="travellersDetaildate col-md-4">
                                            <div className="price text-dark">
                                                <span>15 June 2024</span>
                                            </div>
                                            <div className="price">AED 15.39</div>
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-md-12">
                                            <small>Flat AED 15.39 up to 10 kms</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button className="bookSeatBtn">Continue Booking</button>
                    </div>
                </div>

            </div>

        </>
    );
};

export default AdsOn;